import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';

export const FilterSallesContext = createContext({});
function FilterSallesProvider({ children }) {
    
    const [option,setOption] = useState(1)
    

    const storageExcel = async () => {
        try {
            const ids = [3];

            // Fazendo a requisição para gerar o arquivo
            const response = await api.post("/panel/generate/salles", { ids }, {
                responseType: 'blob' // Importante para baixar arquivos binários
            });
    
            // Criando um URL para o blob recebido
            const url = window.URL.createObjectURL(new Blob([response.data]));
    
            // Criando um link temporário para o download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'relatorio.xlsx'); // Nome do arquivo
            document.body.appendChild(link);
            link.click();
    
            // Limpando o objeto URL para liberar memória
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            
        } catch (error) {
            console.error("Erro ao baixar o Excel:", error);
        }
    };
    

    return (
        <FilterSallesContext.Provider value={{option,setOption,storageExcel}} >
            {children}
        </FilterSallesContext.Provider>
    );
}

export default FilterSallesProvider;
